export default __webpack_public_path__ + "static/media/logo-amex.362d262e.png";